import Head from "next/head";
import getConfig from "next/config";

import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import TelesalesForm from "@components/TelesalesForm";
import { getBannersV2Api } from "@lib/api";
import { apiCall } from "@store/app/actions";

const {
  publicRuntimeConfig: {
    settings: { isProd, isStaging, websiteName, cdn },
    content: { websiteTitle },
  },
} = getConfig();

const BANNERS_IDS = {
  altex: {
    stage: "40f663bc-90ad-4b89-8fa6-a7f09daaada8",
    prod: "d1090b0c-45c1-454d-9d86-2b37bcc95ea1",
  },
  mediagalaxy: { stage: "", prod: "251dc9b0-64ce-49a4-8da3-af4e57b0bf14" },
};

const Telesales = ({ topBanner }) => (
  <>
    <Head>
      <title>Vanzari telefonice</title>
    </Head>
    <Breadcrumbs
      breadcrumbs={[
        {
          id: 1,
          level: 99,
          name: "Vanzari telefonice",
        },
      ]}
    />
    <div>
      {Object.keys(topBanner).length > 0 && (
        <>
          {topBanner.file_mobile && topBanner.file_mobile.length !== 0 && (
            <div className="sm:hidden">
              <img
                src={`${cdn}${topBanner.file_mobile}`}
                alt="Vanzari telefonice"
              />
            </div>
          )}

          {topBanner.file_tablet && topBanner.file_tablet.length !== 0 && (
            <div className="hidden sm:block lg:hidden">
              <img
                src={`${cdn}${topBanner.file_tablet}`}
                alt="Vanzari telefonice"
              />
            </div>
          )}

          {topBanner.file && topBanner.file.length !== 0 && (
            <div className="hidden lg:block">
              <img src={`${cdn}${topBanner.file}`} alt="Vanzari telefonice" />
            </div>
          )}
        </>
      )}
    </div>

    <div className="lg:flex md:p-8 space-y-8 lg:space-y-0">
      <div className="lg:w-1/2 py-4 md:px-10 text-xl font-light space-y-8">
        <Heading
          as="h1"
          display="h2"
          title="Vanzari telefonice persoane fizice sau juridice"
          classesProp="font-light"
        />

        <p>Salut!</p>

        <p>
          Ai in plan un proiect care implica achizitie de produse si ai avea
          nevoie de asistenta personalizata din partea unui specialist{" "}
          {websiteTitle}?
        </p>

        <p>Atunci esti in locul potrivit.</p>

        <p>
          Tot ce ai de facut este sa ne lasi datele tale si te vom contacta in
          maximum 3 ore de la plasarea cererii, in timpul programului de lucru.
        </p>
      </div>

      <div className="lg:w-1/2 lg:pr-10">
        <div className="md:p-10 p-4 bg-[#F5FBF4]">
          <Heading
            as="h2"
            display="h2"
            title="Formular de contact"
            classesProp="font-light"
          />

          <div className="py-8">
            <TelesalesForm />
          </div>
        </div>
      </div>
    </div>
  </>
);

Telesales.pageLayout = "default";
Telesales.pageName = "telesales";

Telesales.getInitialProps = async (ctx) => {
  const { reduxStore } = ctx;

  const bannerId =
    isProd && !isStaging
      ? BANNERS_IDS[websiteName].prod
      : BANNERS_IDS[websiteName].stage;

  const pageBanners = await reduxStore.dispatch(
    apiCall({
      apiCall: getBannersV2Api,
      formatResponse: (response) => response.data,
      apiArgs: [{ id: bannerId }],
    })
  );

  if (pageBanners?.images?.length) {
    return { topBanner: pageBanners.images[0] };
  }
};

export default Telesales;
